import { render, staticRenderFns } from "./AdditionalSchoolFinder.vue?vue&type=template&id=c55d8774&scoped=true&"
import script from "./AdditionalSchoolFinder.vue?vue&type=script&lang=js&"
export * from "./AdditionalSchoolFinder.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalSchoolFinder.vue?vue&type=style&index=0&id=c55d8774&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55d8774",
  null
  
)

export default component.exports